import axios from 'axios'

const state = {
    alerts: null,
    transaction: null,
    transactions: null,
}

const getters = {
    alerts (state) {
        return state.alerts
    },
    transaction (state) {
        return state.transaction
    },
    transactions (state) {
        return state.transactions
    },
    // console.log(Object.assign({}, activeUser))
}

const actions = {
    async createAlert({ dispatch }, alertObj) {
        let response = await axios.post('/alerts/newNote', alertObj)
        if(!response.data.error){
            dispatch('navbarCounter', alertObj) 
            return dispatch('fetchAlerts') 
        }
    },
    
    async fetchAlerts({ commit, getters }) {
        let userObj = { userId: getters.user._id }
        let response = await axios.post('/alerts/notes', userObj)
        if(!response.data.error){
            return commit('SET_ALERTS', response.data.result) 
        }
    },
    
    async removeAlert({ dispatch }, alertObj) {
        let response = await axios.post('/alerts/deleteNote', alertObj)
        if(!response.data.error){
            dispatch('navbarCounter', alertObj) 
            return dispatch('fetchAlerts') 
        }
    },
    
    async scanForResults({ dispatch, getters }) {
        let userObj = { userId: getters.user._id }
        let response = await axios.post('/alerts/scan', userObj)
        if(!response.data.error){
            dispatch('navbarCounter', userObj) 
            return dispatch('fetchAlerts') 
        }
    },

    async createTransaction({ dispatch }, eventObj) {
        let response = await axios.post('/transactions/newEvent', eventObj)
        if(!response.data.error){
            dispatch('navbarCounter', eventObj) 
        }
        return response.data
    },
    
    async fetchTransactions({ commit, getters }, itemObj) {
        let userObj = { userId: getters.user._id }
        // used to fetch a specific item transaction details - for MarkAsSold.vue receipt-btn
        if(itemObj){ userObj = itemObj }
        let response = await axios.post('/transactions/events', userObj)
        if(!response.data.error){
            if(itemObj){ return commit('SET_TRANSACTION', response.data.result) }
            return commit('SET_TRANSACTIONS', response.data.result) 
        }
    },

}

const mutations = {
    SET_ALERTS: (state, alerts) => (state.alerts = alerts),
    SET_TRANSACTION: (state, transaction) => (state.transaction = transaction),
    SET_TRANSACTIONS: (state, transactions) => (state.transactions = transactions),
}

export default {
    state,
    getters,
    actions,
    mutations
}